<template>
  <app-base-main :contentStyle="{'flex': 1, 'overflow': 'auto','display': 'flex', 'flex-direction': 'column'}">
    <template #filter-group>
      <app-filter-group
          ref="filterGroup"
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-radio-group
            v-model="filter.paymentStatus"
            :options="paymentStatus"
            @input="inputRadio"
        ></gj-radio-group>
        <gj-market-select
            v-model="filter.marketIds"
            width="170px"
            multiple
            placeholder="全部店铺"
        >
        </gj-market-select>
        <gj-select
            v-model="filter.transferStatus"
            placeholder="全部转账状态"
            :options="[
                {id: '1', text: '成功'},
                {id: '2', text: '失败'},
                {id: '3', text: '未知'},
                {id: '4', text: '处理中'},
                {id: '5', text: '未拨款'},
            ]"
            width="120px"
        ></gj-select>
        <gj-select
            v-model="filter.currency"
            :options="financeProfitReportCurrency"
            :clearable="false"
        ></gj-select>
        <gj-select-date-picker
            v-model="filter.date"
            type="daterange"
            :width="['100px', '200px']"
            :options="[
            {id: '1', text: '结算周期'},
            {id: '2', text: '转账日期'},
        ]"
        ></gj-select-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :width="clientWidth > 1366 ? ['121px', '140px'] : ['120px', '99px']"
            :options="[
            {id: 'accountTail', text: '账户尾号'},
            {id: 'achTracking', text: 'ACH跟踪编号'},
            // {id: 'financialId', text: '财务编号'},
            {id: 'memo', text: '备注'},
        ]"
        ></gj-select-input>
        <template #right>
          <gj-tool-group
              setting help
              :sort-gjtable="$refs.gjTable"
              :table-columns="columns"
              :table-name="tableName"
              :pagination="pagination"
              :loading="loading"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery"
          ></gj-tool-group>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #base-content>
      <div class="flex remittance-record-card" style="padding-bottom: 16px;">
        <gj-card :title="`未付款金额 (${sumMoney.currencySymbol ? sumMoney.currencySymbol : ''})`" :number="amount(sumMoney.unpaidMoney)">
          <template #icon>
            <div class="icon-box flex align-center justify-center icon1">
              <i class="iconfont iconweifukuanjine"></i>
            </div>
          </template>
        </gj-card>

        <gj-card :title="`已付款金额 (${sumMoney.currencySymbol ? sumMoney.currencySymbol : ''})`" :number="amount(sumMoney.paidMoney)">
          <template #icon>
            <div class="icon-box flex align-center justify-center icon2">
              <i class="iconfont iconfukuanjine"></i>
            </div>
          </template>
        </gj-card>

        <gj-card :title="`总金额 (${sumMoney.currencySymbol ? sumMoney.currencySymbol : ''})`" :number="amount(sumMoney.sumMoney)">
          <template #icon>
            <div class="icon-box flex align-center justify-center icon3">
              <i class="iconfont iconzongjijine"></i>
            </div>
          </template>
        </gj-card>

        <gj-card :title="`转账失败金额 (${sumMoney.currencySymbol ? sumMoney.currencySymbol : ''})`" :number="amount(sumMoney.transferFailed)">
          <template #icon>
            <div class="icon-box flex align-center justify-center icon4">
              <i class="iconfont iconshibai"></i>
            </div>
          </template>
        </gj-card>
      </div>

<!--      <el-row class="remittance-record_row">-->
<!--        <el-col :span="6">-->
<!--          <remittance-record-amount-->
<!--              :title="'未付款金额'" :currency="sumMoney.currencySymbol" :amount="sumMoney.unpaidMoney" :color="'#D8DADD'"-->
<!--          >-->
<!--            <img src="./img/1.png" class="img-width"/>-->
<!--          </remittance-record-amount>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <remittance-record-amount-->
<!--              :title="'已付款金额'" :currency="sumMoney.currencySymbol" :amount="sumMoney.paidMoney" :color="'#D8DADD'"-->
<!--          >-->
<!--            <img src="./img/2.png" class="img-width"/>-->
<!--          </remittance-record-amount>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <remittance-record-amount-->
<!--              :title="'总金额'" :currency="sumMoney.currencySymbol" :amount="sumMoney.sumMoney" :color="'#D8DADD'"-->
<!--          >-->
<!--            <img src="./img/3.png" class="img-width"/>-->
<!--          </remittance-record-amount>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <remittance-record-amount-->
<!--              :title="'转账失败金额'" :currency="sumMoney.currencySymbol" :amount="sumMoney.transferFailed" :color="'#D8DADD'"-->
<!--          >-->
<!--            <img src="./img/4.png" class="img-width"/>-->
<!--          </remittance-record-amount>-->
<!--        </el-col>-->
<!--      </el-row>-->
      <div style="flex: 1; overflow: auto;">
      <gj-table
          ref="gjTable"
          adaptParent
          :data="data"
          :columns="columns"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :pagination="pagination"
          :loading="loading"
          :default-sort="{prop: 'financialEventGroupStart', order: 'descending'}"
      >
        <template v-slot:memo="{ row }">
          <gj-edit-input
              :value="row.memo"
              :item="row"
              table-cell-edit
              :on-confirm="onConfirm"
              :pop-title="'编辑备注'"
          ></gj-edit-input>
        </template>
        <template v-slot:download="{row}">
          <template v-if="row.processingStatus === 'Closed'">
            <template v-if="row.downloadLoading">
              <gj-icon class="el-icon-loading"></gj-icon>
            </template>
            <gj-link v-else @click="download(row)">下载</gj-link>
          </template>
          <template v-else>-</template>
        </template>

        <template v-slot:processingStatus="{row}">
          <gj-tag
              v-if="row.processingStatus==='Open'"
              type="text"
              :color="tagColors.green">
            {{ row.processingStatus }}
          </gj-tag>
          <gj-tag
              v-if="row.processingStatus==='Closed'"
              type="text"
              :color="tagColors.gray9Text">
            {{ row.processingStatus }}
          </gj-tag>
        </template>

        <template v-slot:fundTransferStatus="{row}">
          <gj-tag
            v-if="row.fundTransferStatus==='Succeeded'"
            type="plain"
            :color="tagColors.green">
            成功
          </gj-tag>
          <gj-tag
            v-else-if="row.fundTransferStatus==='Failed'"
            type="plain"
            :color="tagColors.red">
            失败
          </gj-tag>
          <gj-tag
            v-else-if="row.fundTransferStatus==='Processing'"
            type="plain"
            :color="tagColors.blue">
            处理中
          </gj-tag>
          <gj-tag
            v-else-if="row.fundTransferStatus==='NoFundsDisbursed'"
            type="plain"
            :color="tagColors.orange">
            未拨款
          </gj-tag>
          <gj-tag
            v-else
            type="plain"
            :color="tagColors.lightGray">
            未知
          </gj-tag>
        </template>

<!--        <template v-slot:op="{ row }">-->
<!--          <gj-button type="text" @click="download(row)">下载</gj-button>-->
<!--        </template>-->
<!--        <template v-slot:financialPayBackId="{row}">-->
<!--          <gj-tooltip :text-line="1" :content="row.financialPayBackId">{{row.financialPayBackId}}</gj-tooltip>-->
<!--        </template>-->
      </gj-table>
      </div>
    </template>

  </app-base-main>
</template>

<script>
  // import RemittanceRecordAmount from "./modal/remittance-record-amount";
  import {queryMixin} from "../../../../minxins";
  import {
    getRemittanceRecord,
    getRemittanceRecordSumMoney,
    updateRemittanceRecordMemo
  } from "../../../../api/finance";
  import {isMeaningful} from "../../../../utils/common";
  import {convertToDate, generateViewParams} from "../../../../utils/date.util";
  import {financeProfitReportCurrency} from "../../../../utils/options";
  import {mapGetters} from "vuex";
  import {exportFile} from "@/api/common";
  import model from './viewConfig'
  import { tagColors } from "@/components/tag/tag-colors";
  import {amount} from "@/filters";

  export default {
    name: "remittance-record",
    // components: {RemittanceRecordAmount},
    mixins: [queryMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    created() {
      this.sort.prop = 'financialEventGroupStart';
    },
    data() {
      return {
        tagColors,
        tableName: 'remittanceRecord',
        filter: {
          paymentStatus: '',
          marketIds: [],
          transferStatus: null,
          currency: '',
          date: {
            key: '1',
            value: null,
          },
          keyword: {
            key: 'accountTail',
            value: null,
          }
        },
        sumMoney: {},
        paymentStatus: [
          {id: '', text: '全部'},
          {id: '1', text: '已付款'},
          {id: '2', text: '未付款'},
        ],
        financeProfitReportCurrency: financeProfitReportCurrency,
        data: [],
        columns: [
          {
            id: 'marketId',
            header: '店铺/国家',
            minWidth: '120px',
            field: 'option:marketId',
            default: true,
            disabled: true,
            options: () => this.marketOption
          },
          {id: 'billingCycle', header: '结算周期', minWidth: '350px', field: 'billingCycle', default: true, sortable: true, sortBy: 'financialEventGroupStart'},
          {
            id: 'processingStatus',
            header: '付款状态',
            minWidth: '120px',
            field: 'slot:processingStatus',
            default: true
          },
          {
            id: 'originalAmount',
            header: '付款金额',
            minWidth: '120px',
            field: 'originalAmount',
            default: true,
            sortable: true,
            align: 'right',
            prefix: 'originalCodeSymbol'
          },
          {id: 'fundTransferDate', header: '转账日期', minWidth: '150px', field: 'fundTransferDate', default: true},
          {
            id: 'beginningAmount',
            header: '账户结账余额',
            minWidth: '120px',
            field: 'beginningAmount',
            default: true,
            sortable: true,
            align: 'right',
            prefix: 'beginningCodeSymbol'
          },
          {
            id: 'fundTransferStatus',
            header: '转账状态',
            minWidth: '120px',
            field: 'slot:fundTransferStatus',
            default: true,
            help: '转账金额为负数时，存在Unknown状态'
          },
          {id: 'accountTail', header: '账户尾号', minWidth: '120px', field: 'accountTail', default: true},
          {
            id: 'achTracking',
            header: 'ACH跟踪编号',
            minWidth: '120px',
            field: 'traceId',
            default: true,
            help: '即Federal ACH Trace ID，如果您的账户在五个工作日后未显示此笔款项，您可联系银行的ACH（联邦自动清算系统）专员，并提供改追踪编码，以追踪此款项'
          },
          // {id: 'financialId', header: '财务ID', minWidth: '120px', field: 'slot:financialPayBackId', default: true, sortable: true},
          {id: 'memo', header: '备注', minWidth: '120px', field: 'slot:memo', default: true},
          {id: 'download', header: '回款明细', width: '80px', field: 'slot:download', default: true, notCustomColumn: true},
          // {id: 'op', header: '操作', minWidth: '120px', field: 'slot:op', fixed: 'right', default: true, disabled: true},
        ],
        moduleName: 'REMITTANCE-RECORD',
        model,
        cacheOptions: {
          useCache: true,
        }
      }
    },
    methods: {
      amount,
      inputRadio() {
        this.$gjNoticeQuery()
      },
      generateViewParams,
      loadViewComplete () {
        this.$emit('query')
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{marketIds: *}}
       */
      $gjCacheCallback(params) {
        return {
          paymentStatus: params.paymentStatus,
          marketIds: params.marketIds
        };
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            paymentStatus: this.filter.paymentStatus,
            marketIds: this.filter.marketIds,
            transferStatus: this.filter.transferStatus,
            timeType: this.filter.date.key,
            currency: this.filter.currency,
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if (isMeaningful(this.filter.date.value)) {
          params.model.startDate = convertToDate(this.filter.date.value[0]);
          params.model.endDate = convertToDate(this.filter.date.value[1]);
        }
        getRemittanceRecord(params)
          .then((data) => {
            this.data = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false);
        getRemittanceRecordSumMoney(params.model)
          .then((data) => {
            this.sumMoney = data;
          })
      },
      $gjQueryInitParams() {
        return {
          filter: {
            paymentStatus: '',
            marketIds: [],
            transferStatus: null,
            currency: '',
            date: {
              key: '1',
              value: null,
            },
            keyword: {
              key: 'accountTail',
              value: null,
            }
          }
        }
      },
      onConfirm(memo, data, closeEditor) {
        const vm = this;
        updateRemittanceRecordMemo({id: data.id, memo: memo})
          .then(() => {
            vm.$gjMessage.success('操作成功');
            vm.$gjResetPage();
            data.memo = memo;
            closeEditor();
          });
      },
      download(row) {
        this.$set(row, 'downloadLoading', true);
        exportFile(`/finance/financialPayBack/downloadPayBack?id=${row.id}`)
          .complete(() => {
            this.$set(row, 'downloadLoading', false);
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.flex{

}
.gj-card {
  flex: 1;
  border-radius: 2px;
}
.remittance-record-card {
  .gj-card {
    margin-right: 0;
  }
}

.gj-card + .gj-card {
  margin-left: 16px;
}
.icon-box{
  width: 100%;height: 100%;border-radius: 16px;
  .iconfont{
    font-size: 20px;
  }
}
.icon1{
  background: #FFE1E0;
  .iconfont{
    color:  $gj-color-danger;
  }
}
.icon2{
  background:  #D1F0D6;
  .iconfont{
    color:  $gj-color-success;
  }
}
.icon3{
  background: #D6E9FB;
  .iconfont{
    color:  $gj-color-primary;
  }
}
.icon4{
  background: #EFE0FB;
  .iconfont{
    color:  $gj-color-purple;
  }
}


  .img-width {
    width: 60px;
    height: 60px;
  }
  .content{
    border: 2px solid;
    border-radius: 2px;
  }
  .remittance-record_row{
    display: flex; 
    width: 100%;
    background-color: #fff;
    justify-content: space-between;
    padding: 4px 0 16px 0;
    /deep/ .el-col-6{
      margin-right: 20px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>
